enum DocumentImportFormFieldNames {
  // Step 1 — source selection
  SourceKind = 'sourceKind',
  Files = 'files',
  Archive = 'archive',
  FtpUrl = 'ftpUrl',
  FtpUsername = 'ftpUsername',
  FtpPassword = 'ftpPassword',
  // Persisted from the FTP preview so the step-2 "Total documents" footer
  // can read the supported-files count (the preview result is otherwise
  // only held in FtpPreviewBlock's local state on step 1).
  FtpSupportedFilesCount = 'ftpSupportedFilesCount',
  // Step 2 — AI prefill options (shown only when AiAssistance is enabled).
  // AiEnhancements holds the selected DocumentImportAiEnhancementOption
  // values as SelectOption[]; mapped to the import input's nested
  // detectFields flags in getPreparedImportData.
  AiEnhancements = 'aiEnhancements',
  AiCodeInstructions = 'aiCodeInstructions',
  // Step 2 — shared metadata is reused from DocumentFormFieldNames
}

// Values selectable in the AiEnhancements multi-select — mirror
// DocumentationImportDetectFieldsInputObject's flag names so
// getPreparedImportData can map them directly.
export enum DocumentImportAiEnhancementOption {
  DetectName = 'detectName',
  DetectCategory = 'detectCategory',
  DetectDescription = 'detectDescription',
  DetectCode = 'detectCode',
  DetectTags = 'detectTags',
}

export default DocumentImportFormFieldNames;
